import React from 'react';
import ButtonAnnul from '../modules/events/components/ButtonAnnul';
import ReusableButton from '../reusables/Button';
import WarningMessage from '../reusables/WarningMessage';

interface RenderButtonProps {
  isSubscribed: boolean;
  isProfessionalTools?: boolean;
  canUnsubscribe?: boolean;
  onCancel: () => void;
  onSubscribe: () => void;
  logEvent?: () => void;
  disableSubscribe?: boolean;
}

const RenderButton: React.FC<RenderButtonProps> = ({
  isSubscribed,
  isProfessionalTools = false,
  canUnsubscribe = true,
  onCancel,
  onSubscribe,
  logEvent,
  disableSubscribe = false
}) => {
  if (isSubscribed) {
    if (isProfessionalTools && !canUnsubscribe) {
      return (
        <WarningMessage
          styledProps={{
            background: '#D5E5F0',
            padding: '16px'
          }}
          message="El taller ya comenzó y no se puede anular la inscripción. Si no puedes asistir, revisa las grabaciones."
        />
      );
    }
    return <ButtonAnnul onClick={onCancel} />;
  }

  return (
    <ReusableButton
      disabled={disableSubscribe}
      text="Inscribirme"
      style={{ padding: '12px 24px' }}
      onClick={() => {
        if (logEvent) {
          logEvent();
        }
        onSubscribe();
      }}
    />
  );
};

export default RenderButton;
